module.exports = __webpack_public_path__ + "img/avatar7.df9d4209.png";